import api from './api'

const voszPortBasePath = '/api/v1/voszport'

export async function getStatus(email) {
  const resp = await api.post(`${voszPortBasePath}/get-voszport-user-status`, { email })
  return resp.data
}

export async function getLoginRedirectUrl(email) {
  const resp = await api.post(`${voszPortBasePath}/get-login-redirect-link`, { email })
  return resp.data
}

export async function getRegistRedirectUrl(userId) {
  const resp = await api.post(`${voszPortBasePath}/get-register-redirect-link`, { userId })
  return resp.data
}
